<template>
	<div id="launcher-download" :class="themeClass">
		<div class="content">
			<span class="title">{{ $t('main.download-launcher.title') }}</span>
			<span class="desc">{{ $t('main.download-launcher.desc') }}</span>
			<button :class="{ offPlatform: !isWindows }" @click="downloadLauncher">
				<svgIcon v-if="isWindows" icon-holder-class="download" icon-id="icon-btn-download" />
				<span class="download-title">{{ $t(`main.download-launcher.button.${isWindows ? 'enabled' : 'disabled'}`) }}</span>
			</button>
			<div class="system-reqs">
				<span>{{ $t('main.download-launcher.sys-reqs.title') }}</span>
				<span>{{ $t('main.download-launcher.sys-reqs.os') }}</span>
				<span>{{ $t('main.download-launcher.sys-reqs.memory') }}</span>
				<span>{{ $t('main.download-launcher.sys-reqs.hard-drive') }}</span>
				<span>{{ $t('main.download-launcher.sys-reqs.network') }}</span>
			</div>
			<div class="support">
				<span>{{ $t('main.download-launcher.support.title') }}</span>
				<i18n path="main.download-launcher.support.desc" tag="span">
					<template v-slot:supportLink>
						<br class="support-break" />
						<a :href="supportLinks[cmsRegionCode]" target="_blank" rel="external">{{
							$t('main.download-launcher.support.click-here')
						}}</a>
					</template>
				</i18n>
			</div>
		</div>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import { mapActions, mapGetters, mapState } from 'vuex';
import { SupportLinks } from '../config/config-cdn';
import downloadGame from '../plugins/launcherDownload';

export default {
	name: 'LauncherDownload',
	components: {
		svgIcon,
	},
	data() {
		return {
			supportLinks: SupportLinks,
		};
	},
	computed: {
		...mapGetters(['cmsRegionCode']),
		...mapState(['isWindows']),
		themeClass() {
			return !this.prodId ? '' : `product-${this.prodId}-landing`;
		},
		prodId() {
			return this.$route.query.prod_id;
		},
		language() {
			return this.$i18n.locale;
		},
		NXLogSessionId() {
			return this.$cookie.get('NxLogSession') ? this.$cookie.get('NxLogSession') : new Date().toISOString();
		},
		region() {
			return environment.region;
		},
		memberShipNo() {
			return this.region === 'global' ? 1 : this.region === 'th' ? 3 : this.region === 'tw' ? 4 : this.region === 'sea' ? 5 : null;
		},
	},
	async created() {
		this.checkRegionInfo();
	},
	methods: {
		...mapActions(['checkRegionInfo']),
		downloadLauncher() {
			if (!this.isWindows) return;
			dataLayer.push({
				event: 'launcherDownloadPage',
			});
			downloadGame(10000, this.NXLogSessionId, this.memberShipNo, this.language, this.$route.query.partnerKey);
		},
	},
};
</script>
<style lang="less" scoped>
#launcher-download {
	&.product-10100-landing {
		background-image: url('~@/images/launcher-info/download/bg-ms_mobile.jpg');
	}
	background: transparent no-repeat center top;
	background-image: url('~@/images/launcher-info/download/bg-default_mobile.jpg');
	background-size: cover;
	color: rgba(255, 255, 255, 0.502);
	font-family: Roboto;
	font-size: 22.5px;
	line-height: 1.2;
	padding: 56px 20px 0;
	text-align: center;
	user-select: none;
	.content {
		align-items: center;
		display: flex;
		flex-direction: column;
		margin: 15px 0 0;
		width: 100%;
		.title {
			color: rgb(255, 255, 255);
			font-size: 45px;
			margin-bottom: 10px;
		}
		.desc {
			width: 100%;
		}
		button {
			align-items: center;
			background-color: #0077ff;
			border: none;
			border-radius: 10px;
			box-shadow: none;
			color: rgb(255, 255, 255);
			display: flex;
			font-size: 27px;
			height: 117px;
			justify-content: center;
			margin: 20px 0;
			max-width: 728px;
			outline: 0;
			padding: 0 20px 0 18px;
			text-transform: uppercase;
			transition: background-color 0.2s, background-color 0.2s, border-color 0.2s, color 0.2s;
			width: 100%;
			&:not(:active):not(.offPlatform):hover {
				background-color: #4ca1ff;
			}
			&:active:not(.offPlatform) {
				background-color: #0c5097;
				color: rgba(255, 255, 255, 0.5);
				.download {
					opacity: 0.5;
				}
			}
			&.offPlatform {
				background-color: rgb(83, 83, 83);
				color: rgba(255, 255, 255, 0.5);
				cursor: default;
				font-size: 22.5px;
				text-transform: none;
				.download {
					opacity: 0.5;
				}
			}
			.download {
				height: 24px;
				margin: 0 10px 0 0;
				width: 20px;
			}
		}
		.system-reqs,
		.support {
			> :first-child {
				color: rgb(255, 255, 255);
			}
			a {
				color: rgba(255, 255, 255, 0.502);
				text-decoration: underline;
			}
			display: flex;
			flex-direction: column;
			margin-bottom: 20px;
			max-width: 650px;
		}
		.support {
			margin-bottom: 25px;
			max-width: 500px;
			.support-break {
				display: none;
			}
		}
	}
}

@media (min-width: 768px) {
	#launcher-download {
		&.product-10100-landing {
			background-image: url('~@/images/launcher-info/download/bg-ms.jpg');
		}
		background-image: url('~@/images/launcher-info/download/bg-default.jpg');
		font-size: 18px;
		line-height: 1.333;
		padding-bottom: 10px;
		.content {
			background-color: rgb(21, 21, 23);
			border-radius: 5px;
			margin: 50px auto;
			opacity: 0.902;
			padding: 40px;
			width: 600px;
			.title {
				font-size: 36px;
				line-height: 0.5;
				margin-bottom: 40px;
				max-width: 100%;
			}
			.desc {
				max-width: 90%;
			}
			button {
				border-radius: 5px;
				height: 70px;
				margin: 30px 0;
				max-width: 500px;
				&.offPlatform {
					font-size: 18px;
				}
			}
			.support {
				margin-bottom: 0;
				.support-break {
					display: block;
				}
			}
		}
	}
}
</style>
